const breakpoints = [ 576, 768, 992, 1366 ];

const theme = {
    colors: {
        common: {
            text: '#D3A145',
            background: '#060201',
            lightBackground: '#F0C74B'
        },
        inverted: {
            background: '#D3A145',
            text: '#060201'
        },
        primary: {
            main: '#D3A145',
            dark: '#060201',
            light: '#F0C74B',
            contrastColor: '#A4230D',
            mainHover: '#DCA430',
            contrastHover: '#88070F',
            gray: '#d4d4d4'
        },
        grey: {
            main: '#E8E8E8'
        },
        error: {
            dark: '#A91414',
            main: '#CA1515',
            light: '#E54C4C',
            lighter: '#FFDDDD',
            contrastText: '#D3A145'
        },
        warning: {
            dark: '#A99014',
            main: '#CAAC15',
            light: '#FFD569',
            contrastText: '#141414'
        },
        success: {
            dark: '#05532B',
            main: '#1E794B',
            light: '#64BC90',
            lighter: '#DDFFDD',
            contrastText: '#FFFFFF'
        },
        info: {
            main: '#007bff'
        },
        primaryDark: '#040404',
        primaryLight: '#FFFFFF',
        activeLight: '#EEEEEE',
        secondaryLight: '#F8F8F8',
        secondary: '#363636',
        secondaryDark: '#E6E6E6',
        tertiary: '#363636',
        tertiaryLight: '#363636',
        backgroundColor: '#E8E8E8',
        errorColorDark: '#A91414',
        errorColor: '#CA1515',
        errorColorLight: '#E54C4C',
        warningColorDark: '#A99014',
        warningColor: '#CAAC15',
        warningColorLight: '#FFD569',
        successColorDark: '#05532B',
        successColor: '#1E794B',
        successColorLight: '#64BC90'
    },
    spacing: {
        xxxs: '4px',
        xxs: '8px',
        xs: '16px',
        s: '24px',
        m: '32px',
        l: '40px',
        xl: '62px',
        xxl: '80px',
        xxxl: '106px'
    },
    borderRadius: {
        s: '4px',
        m: '8px',
        l: '16px'
    },
    mediaQuery: {
        mobileOnly: `@media (max-width: ${breakpoints[0] - 1}px)`,
        largeMobileOnly: `@media (max-width: ${breakpoints[1] - 1}px)`,
        largeMobileUp: `@media (min-width: ${breakpoints[0]}px)`,
        tabletUp: `@media (min-width: ${breakpoints[1]}px)`,
        tabletLandscapeUp: `@media (min-width: ${breakpoints[2]}px)`,
        desktopUp: `@media (min-width: ${breakpoints[3]}px)`
    },
    typography: {
        fontFamily: "'Times New Roman', serif",
        h1: {
            fontSize: '48px',
            lineHeight: '130%',
            fontWeight: 700
        },
        h2: {
            fontSize: '32px',
            lineHeight: '130%',
            fontWeight: 700
        },
        h3: {
            fontSize: '28px',
            lineHeight: '130%',
            fontWeight: 700
        },
        h4: {
            fontSize: '24px',
            lineHeight: '130%',
            fontWeight: 700
        },
        h5: {
            fontSize: '20px',
            lineHeight: '130%',
            fontWeight: 700
        },
        h6: {
            fontSize: '18px',
            lineHeight: '150%',
            fontWeight: 600
        },
        p: {
            fontSize: '18px',
            lineHeight: '160%',
            fontWeight: 400
        },
        pBold: {
            fontSize: '18px',
            lineHeight: '160%',
            fontWeight: 600,
            opacity: 0.9
        },
        pTiny: {
            fontSize: '16px',
            lineHeight: '150%',
            fontWeight: 400,
            opacity: 0.8
        }
    },
    size: {
        headerHeight: '80px',
        footerHeight: '207.16px',
        mintWidth: '60px',
        mintHeight: '25px',
        assetWidth: '300px',
        secondaryMarketLogosWidth: '150px',
        assetWidthTiny: '240px',
        loadingHeight: '100px',
        loadingWidth: '100px',
        loadingBorder: '8px',
        gridItemButtonsWidth: 200,
        dropdownWidth: 180,
        templateWidth: 100,
        templateHeight: 100
    },
    shadow: {
        dropShadow: '5px 5px 30px 2px rgba(0,0,0,0.2)',
        dropShadowGridButtons: '4px 4px 10px 4px #000000',
        dropShadowCard: '4px 4px 8px 2px #00000077'
    },
    transition: {
        default: 'all 150ms cubic-bezier(0.4, 0, 0.2, 1)'
    },
    select: {
        option: (provided, state) => ({
            ...provided,
            color:
        state.isSelected || state.isFocused
            ? theme.colors.primary.main
            : theme.colors.primary.dark,
            backgroundColor:
        state.isSelected || state.isFocused
            ? theme.colors.primary.contrastColor
            : theme.colors.primary.light
        }),
        control: (base) => ({
            ...base,
            border: `1px solid ${theme.colors.primary.main}`,
            backgroundColor: theme.colors.primary.light,
            '&:hover': { borderColor: theme.colors.primary.contrastColor },
            boxShadow: 'none'
        }),
        placeholder: (base) => ({
            ...base,
            color: theme.colors.primary.dark
        }),
        input: (base) => ({
            ...base,
            color: theme.colors.primary.dark
        }),
        dropdownIndicator: (base) => ({
            ...base,
            color: theme.colors.primary.dark,
            '&:hover': { color: theme.colors.primary.contrastColor }
        }),
        clearIndicator: (base) => ({
            ...base,
            color: theme.colors.primary.dark,
            '&:hover': { color: theme.colors.primary.contrastColor }
        }),
        indicatorSeparator: (base) => ({
            ...base,
            backgroundColor: theme.colors.primary.dark
        }),
        menu: (base) => ({
            ...base,
            backgroundColor: theme.colors.primary.light
        })
    }
};

export default theme;
